export enum CONTACT_TAB {
    CONTACT = 'contact',
    CONTACT_GROUP = 'contact-group',
}
